import { Close } from 'components/icons'
import { BaseButton } from 'components/library/buttons'
import InputField from 'components/library/input-fields/InputField'
import SelectField from 'components/library/input-fields/SelectField'
import { Province } from 'utils/constants'
import Translate from 'lang/Translate'
import React, { useEffect, useState } from 'react'
import { TCreateScenario, TScenario, scenarioCreateSchema } from '../scenario.model'
import { createScenario, updateScenario } from '../services'
import callApi from 'services/api/callApi'
import { ZodIssue } from 'zod'
import { u } from 'msw/lib/glossary-de6278a9'

interface CreateNewProps {
	handleCloseModal?: () => void // is inherited via HOC props
	reload: () => void,
	editMode ?: boolean,
	editData?: TScenario | null
}

const CreateNew = ({ handleCloseModal = () => { }, reload, editMode, editData }: CreateNewProps) => {
	const [state, setState] = useState<TCreateScenario>({
		name: "",
		frenchName: "",
		casestudyNumber: "",
		taxpayerName: "",
		level: "",
		province: ""
	})
	const [errors, setErrors] = useState<ZodIssue[]>([])
	const [saving, setSaving] = useState<boolean>(false)

	useEffect(()=>{
		if(editMode && editData){
			setState({
				name: editData.name|| "",
				frenchName: editData.frenchName|| "",
				casestudyNumber: editData.casestudyNumber|| "",
				taxpayerName: editData.taxpayerName || "",
				level: editData.level|| "",
				province: editData.province|| ""
			})
		}
		return 
	}, [editMode, editData])

	/* istanbul ignore next */
	const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
		setState({
			...state,
			[e.target.name]: e.target.value
		})
		setErrors([...errors.filter(d => !d.path.includes(e.target.name))])
	}

	/* istanbul ignore next */
	const handleCreateScenario = async () => {
		const validation = scenarioCreateSchema.safeParse(state);
		if (validation.success) {
			setSaving(true)
			const { success } = await callApi<boolean>("SCENARIO/CREATE", createScenario(state))
			if (success) {
				handleCloseModal()
				reload()
			}
			setSaving(false)
		} else {
			setErrors(validation.error.issues);
		}
	}

	const handleUpdateScenario  = async() => {
		const validation = scenarioCreateSchema.safeParse(state);
		if(validation.success){
			setSaving(true);
			// call api 
			const { success } = await callApi<boolean>("SCENARIO/UPDATE", updateScenario(editData?.id || 0, state));
			if(success){
				handleCloseModal();
				reload();
			}
		}
		else{
			setErrors(validation.error.issues);
		}


	}

	return (
		<div className='create-scenario-modal' data-testid="create-new">
			<div className='header flex-center border-bottom mb-4 is-justify-content-space-between'>
				<div className='flex-center'>
					<Translate className='is-size-5 has-text-weight-bold' text= {editMode ? "Buttons.update_scenario" :"Buttons.create_new_scenario"} />
				</div>
				<div className='flex-center pointer' data-testid="close-create-modal" onClick={handleCloseModal} tabIndex={0}>
					<Close />
				</div>
			</div>
			<div className='inputs-container'>
				<InputField errors={errors} fieldId="name" labelKey="scenario_name" value={state.name} onChange={handleValueChange} autofocus />
				<InputField errors={errors} fieldId="frenchName" labelKey="frenchName" value={state.frenchName} onChange={handleValueChange} />
				<InputField errors={errors} fieldId="casestudyNumber" labelKey="casestudyNumber" value={state.casestudyNumber} onChange={handleValueChange} />
				<InputField errors={errors} fieldId="taxpayerName" labelKey="taxpayerName" value={state.taxpayerName} onChange={handleValueChange} />
				<InputField errors={errors} fieldId="level" labelKey="level" value={state.level} onChange={handleValueChange} />
				<SelectField errors={errors} fieldId="province" labelKey="province" selectedValue={state.province} onChange={handleValueChange} options={Province} />
				{editMode ? 
				  <BaseButton loading={saving} fieldId="" labelKey="Buttons.update_scenario" buttonStyles='is-primary w-100 mt-4' onClick={handleUpdateScenario} />
				: <BaseButton loading={saving} fieldId="" labelKey="Buttons.Create_Scenario" buttonStyles='is-primary w-100 mt-4' onClick={handleCreateScenario} />}
				<BaseButton fieldId="" labelKey="Buttons.cancel" buttonStyles='is-text w-100 mb-2 mt-2' onClick={handleCloseModal} />
			</div>
		</div>
	)
}

export default CreateNew